const Header = ({name}) => {
	return (
		<div className='callHeader'>
			<div className='callName' >{name}</div>
			<div className='callDescription' >מתקשרת...</div>
		</div>
	)
}

export default Header